import type { InstanciaPublic } from '@app/shared';
import { useQuery } from '@tanstack/react-query';

import { api } from '../../../lib/api';
import { qk } from '../../../lib/queryKeys';

// Los números de Metamorfosis en Evolution (Ciclo 1b, R1). Son datos: la UI toma
// etiqueta y color de acá y nunca los escribe en un componente.
export const instanciasApi = {
  async list(): Promise<{ instancias: InstanciaPublic[] }> {
    const { data } = await api.get<{ instancias: InstanciaPublic[] }>('/instancias');
    return data;
  },
};

export type MapaInstancias = Record<string, InstanciaPublic>;

/** Las instancias activas, en orden, y un mapa por nombre. Cambian casi nunca. */
export function useInstancias(): { instancias: InstanciaPublic[]; porNombre: MapaInstancias } {
  const q = useQuery({
    queryKey: qk.instancias.all,
    queryFn: instanciasApi.list,
    staleTime: 5 * 60_000,
  });
  const instancias = q.data?.instancias ?? [];
  const porNombre: MapaInstancias = {};
  for (const i of instancias) porNombre[i.nombre] = i;
  return { instancias, porNombre };
}

/** Etiqueta corta para mostrar; si la instancia no está cargada, el nombre tal cual. */
export function etiquetaDe(porNombre: MapaInstancias, nombre: string): string {
  return porNombre[nombre]?.etiqueta ?? nombre;
}
